// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__3PDxL","inputDescription":"styles_inputDescription__UCs-H"};